// extracted by mini-css-extract-plugin
module.exports = {"container":"FaqItem_container__2nJcK","question":"FaqItem_question__1LyV2","answer":"FaqItem_answer__Dbdj3"};